import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  Checkbox,
  CTA,
  CustomInput,
  CustomSelect,
  Inline,
  Text,
} from '../../../ui/atoms';
import { Container } from '../../../ui/gridSystem';
import {
  newForm,
  newFormField,
  getValues,
  isValidForm,
} from '../../../utils/form';
import { RegexpType, validator } from '../../../utils/validator';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import InputLegend from '../../../ui/atoms/InputLegend';
import CustomTextarea from '../../../ui/atoms/CustomTextarea';
import {
  Footer,
  FormWrapper,
  GroupCard,
  GroupsBox,
  InputRow,
  Legend,
  SelectedGroupsBox,
  Separator,
  TemplateControlsWrapper,
  TemplateLabelAndControls,
  TitleWrapper,
} from './style';
import {
  NEWSLETTER_BASE_TEMPLATE_GET,
  NEWSLETTER_SEND,
} from '../../redux/actions/newsletter';
import { timestampToDate } from '../../../utils/common';
import { apiHost, baseUrl } from '../../api/config';
import { withFileUploader } from '../../hoc/withFileUploader';
import CustomToggle from '../../../ui/atoms/CustomToggle';
import theme from '../../../ui/theme';
import { MODAL_OPEN } from '../../redux/actions';
import ModalCancelCourse, {
  ModalCancelCourseId,
} from '../../../ui/atoms/Modals/ModalCancelCourse';
import { STATS_GROUP_LIST_GET } from '../../redux/actions/statistics';
import Pagination from '../../../ui/atoms/Pagination';

const acceptedFiles = ['.jpg', '.jpeg', '.png'];

const initialForm = newForm([
  newFormField({
    field: 'title',
    required: true,
    type: RegexpType.STRING,
    valid: true,
  }),
  /* //? "subtitle" field is ko
  newFormField({
    field: 'subtitle',
    required: true,
    type: RegexpType.STRING,
    valid: true,
  }),
  */
  newFormField({
    field: 'body',
    required: true,
    type: RegexpType.STRING,
    valid: true,
  }),
]);

const SendNewsletter = ({
  sentCounter,
  groups,
  pager,
  getGroups,
  baseTemplate,
  loadBaseTemplate,
  sendNewsletter,
  onFileChange,
  mediaIsPhone,
  modalOpen,
}) => {
  const [form, setForm] = useState(initialForm);
  const [groupSearch, setGroupSearch] = useState('');
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [file, setFile] = useState();
  const [fileId, setFileId] = useState();
  const [preview, setPreview] = useState(false);
  const [filters, setFilters] = useState({ items_per_page: 12 });

  useEffect(() => {
    getGroups(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  useEffect(() => {
    setForm(initialForm);
    setSelectedGroups([]);
    // setExcludedGroups([]);
    // setSelectedUsers([]);
  }, [sentCounter]);

  const handleOnChange = useCallback(
    (field = '', newValue) => {
      const { type, required } = form[field];
      setForm({
        ...form,
        [field]: {
          ...form[field],
          value: newValue,
          valid:
            typeof newValue !== 'object'
              ? validator(type, newValue, required)
              : true,
        },
      });
    },
    [form]
  );

  const handleOnSend = () => {
    const fileToUpload = document.querySelector('input[type=file]').files[0];
    onFileChange({
      file: fileToUpload,
      key: 'newsletter_image',
      url: `${apiHost}${baseUrl}pzzl_newsletter/newsletters/images/upload`,
      callback: (_file, data) => {
        setFileId(data?.id);
      },
    });
  };

  useEffect(() => {
    if (fileId) {
      const body = {
        ...getValues(form),
        included_group_ids: selectedGroups,
        newsletter_image: Number(fileId?.length > 0 ? fileId[0] : fileId),
        body: form.body.value?.replaceAll('<br />', ''),
      };

      sendNewsletter(body);
      setFile();
      setFileId();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileId]);

  useEffect(() => {
    if (baseTemplate) {
      handleOnChange('body', baseTemplate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseTemplate]);

  const toggleGroup = (gId) => {
    const newGroupIds = [...selectedGroups];
    const groupIndex = newGroupIds.findIndex((g) => g === gId);
    if (groupIndex < 0) newGroupIds.push(gId);
    else newGroupIds.splice(groupIndex, 1);

    setSelectedGroups(newGroupIds);
  };

  const loadMore = (page) => getGroups({ ...filters, page });
  const setItemsPerPage = (v) =>
    setFilters({ ...filters, items_per_page: v?.value });

  return (
    <>
      <Container>
        <TitleWrapper>
          <Text type="h1">Creazione newsletter</Text>
          <CTA
            type="tertiary"
            btnText="ESCI DALLA MODALITà DI CREAZIONE"
            onClick={() => modalOpen(ModalCancelCourseId)}
            icon="x-close"
          />
        </TitleWrapper>
        <Text type="b3" mb={40}>
          Sezione dedicata alla creazione e invio newsletter.
        </Text>
        <FormWrapper>
          <InputRow columnGap={140} rowGap={40}>
            <div>
              <InputLegend
                label="Titolo newsletter"
                required={form.title.required}
                htmlFor="newsletter-title"
              />
              <CustomInput
                size={mediaIsPhone ? 'full' : 'l'}
                placeholder="Inserisci"
                onChange={(value) => handleOnChange('title', value)}
                value={form.title.value || ''}
                id="newsletter-title"
              />
            </div>
            <div>
              <InputLegend
                label="Immagine newsletter"
                required
                tooltipKey="newsletter_img_cover"
              />
              <InputRow columnGap={24} rowGap={16}>
                <CTA
                  btnText="Seleziona file"
                  onClick={() =>
                    document.querySelector('input[type=file]').click()
                  }
                  fullsize={mediaIsPhone}
                />
                <input
                  type="file"
                  className="d-none"
                  onChange={() => {
                    const fileToUpload =
                      document.querySelector('input[type=file]').files[0];
                    setFile(fileToUpload);
                  }}
                  accept={acceptedFiles.join(',')}
                />
                {file ? (
                  <div className="d-flex">
                    <Text type="b3">{file?.name}</Text>
                    <CTA
                      type="tertiary"
                      btnText="Elimina"
                      icon="trash-01"
                      onClick={() => {
                        setFile();
                        setFileId();
                      }}
                    />
                  </div>
                ) : (
                  <Text type="b3">Nessun file selezionato</Text>
                )}
              </InputRow>
            </div>
          </InputRow>
          {/* //? "subtitle" field is ko
          <div>
            <InputLegend label="Sottotitolo" required={form.subtitle.required} htmlFor="newsletter-subtitle" />
            <CustomInput
              size="l"
              placeholder="Sottotitolo"
              id="newsletter-subtitle"
              onChange={(value) => handleOnChange('subtitle', value)}
              value={form.subtitle.value || ''}
            />
          </div>
          */}
          <div>
            <TemplateLabelAndControls>
              <InputLegend
                label="Descrizione"
                required={form.body.required}
                mb={0}
              />
              <TemplateControlsWrapper>
                <Inline columnGap="16px">
                  <InputLegend
                    label="Vedi anteprima"
                    mb={0}
                    htmlFor="newsletter-preview"
                  />
                  <CustomToggle
                    checked={preview}
                    id="newsletter-preview"
                    onClick={() => setPreview(!preview)}
                  />
                </Inline>
                <CTA
                  btnText="Carica template base"
                  onClick={() => {
                    if (baseTemplate) handleOnChange('body', baseTemplate);
                    else loadBaseTemplate();
                  }}
                  fullsize={mediaIsPhone}
                />
              </TemplateControlsWrapper>
            </TemplateLabelAndControls>
            <Text type="b4" mb={8}>
              Per poter inviare la newsletter bisogna effettuare almeno una
              modifica al template base
            </Text>
            {preview ? (
              <iframe
                srcDoc={form.body?.value?.replaceAll('<br />', '\n')}
                title="template-preview"
                width="100%"
                height={380}
              />
            ) : (
              <CustomTextarea
                placeholder="Inserisci"
                value={form.body?.value || ''}
                onChange={(value) => handleOnChange('body', value)}
                mb={0}
                minHeight={380}
                id="newsletter-textarea"
              />
            )}
          </div>
          <Separator />
          <GroupsBox>
            <Text type="h2" mb={8}>
              Destinatari
            </Text>
            <Text type="b3" mb={32}>
              Seleziona i destinatari a cui inviare la newsletter.
            </Text>
            <div>
              <InputLegend
                label="Ricerca gruppi"
                required
                tooltipKey="select_group"
                type="secondary"
              />
              <InputRow columnGap={32} rowGap={16}>
                <CustomInput
                  size={mediaIsPhone ? 'full' : 'l'}
                  placeholder="Cerca gruppi"
                  onChange={(v) => setGroupSearch(v)}
                  value={groupSearch}
                />
                <CTA
                  btnText="Cerca"
                  onClick={() => {
                    setFilters({ ...filters, search_text: groupSearch });
                  }}
                  fullsize={mediaIsPhone}
                />
              </InputRow>
            </div>
            <SelectedGroupsBox>
              <Text type="h2" mb={mediaIsPhone ? 32 : 24}>
                Seleziona i gruppi
              </Text>
              <Text type="b4" mb={mediaIsPhone ? 16 : 24}>
                {selectedGroups?.length !== 1
                  ? `${selectedGroups?.length} gruppi selezionati`
                  : '1 gruppo selezionato'}
              </Text>
              {!mediaIsPhone && (
                <Legend>
                  <div />
                  <Text type="statistics-heading">NOME GRUPPO</Text>
                  <Text type="statistics-heading">Numero di utenti</Text>
                  <Text type="statistics-heading">DATA DI CREAZIONE</Text>
                </Legend>
              )}
              {(groups || []).map((g) => {
                if (mediaIsPhone) {
                  return (
                    <GroupCard key={`gruppo-${g.id}`}>
                      <Text type="statistics-heading">NOME GRUPPO</Text>
                      <Text type="h3">{g?.name}</Text>
                      <Text type="statistics-heading">Numero di utenti</Text>
                      <Text type="b4">{g?.total_users}</Text>
                      <Text type="statistics-heading">DATA DI CREAZIONE</Text>
                      <Text type="b4">{timestampToDate(g?.creation_date)}</Text>
                      <Checkbox
                        onChange={() => toggleGroup(g.id)}
                        checked={selectedGroups?.includes(g.id)}
                        label={
                          selectedGroups?.includes(g.id)
                            ? 'Deseleziona'
                            : 'Seleziona'
                        }
                      />
                    </GroupCard>
                  );
                }
                return (
                  <GroupCard key={`gruppo-${g.id}`}>
                    <div className="checkbox-wrapper">
                      <Checkbox
                        onChange={() => toggleGroup(g.id)}
                        checked={selectedGroups?.includes(g.id)}
                      />
                    </div>
                    <Text type="h3">{g?.name}</Text>
                    <Text type="b4">{g?.total_users}</Text>
                    <Text type="b4">{timestampToDate(g?.creation_date)}</Text>
                  </GroupCard>
                );
              })}
              {pager && (
                <Pagination
                  pt={24}
                  pb={24}
                  pager={pager}
                  callBack={loadMore}
                  setItemsPerPage={setItemsPerPage}
                />
              )}
            </SelectedGroupsBox>
          </GroupsBox>
        </FormWrapper>
        {mediaIsPhone && (
          <Text type="b3" mt={40} mb={40} color={theme().colors.fail}>
            * campo obbligatorio
          </Text>
        )}
      </Container>
      <Footer>
        <Container className="pt-0">
          <div className="d-flex sb">
            {!mediaIsPhone && (
              <Text type="b3" color={theme().colors.fail}>
                * campo obbligatorio
              </Text>
            )}
            <CTA
              btnText="Invia newsletter"
              onClick={handleOnSend}
              disabled={
                !isValidForm(form) || !file || !selectedGroups?.length > 0
              }
              bottomRight
              fullsize={mediaIsPhone}
            />
          </div>
        </Container>
      </Footer>
      <ModalCancelCourse />
    </>
  );
};

SendNewsletter.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // HOC state
  groups: PropTypes.array,
  pager: PropTypes.object,
  sentCounter: PropTypes.number,
  baseTemplate: PropTypes.string,
  // HOC dispatch
  loadBaseTemplate: PropTypes.func,
  getGroups: PropTypes.func,
  sendNewsletter: PropTypes.func,
  modalOpen: PropTypes.func,
  // HOC
  onFileChange: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const {
        groups: { list: groups, pager },
      } = state.statistics;
      const { sentCounter, baseTemplate } = state.newsletter;
      return { groups, pager, sentCounter, baseTemplate };
    },
    (dispatch) => ({
      getGroups: (filters) =>
        dispatch({ type: STATS_GROUP_LIST_GET._REQUEST, filters }),
      sendNewsletter: (body) =>
        dispatch({ type: NEWSLETTER_SEND._REQUEST, body }),
      loadBaseTemplate: () =>
        dispatch({ type: NEWSLETTER_BASE_TEMPLATE_GET._REQUEST }),
      modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
    })
  ),
  withFileUploader
)(withMediaQueries(SendNewsletter));
